import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import "./Mgrdetail.css";

export default function AulphaDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          Aulpha Technologies
        </h1>

        <p className="project-description">
          We partnered with Aulpha Technologies to design a comprehensive corporate brand identity system and premium print collaterals. Our deliverables included professional visiting cards, corporate brochures, letterheads, table calendars, certificates, diaries, and flyers, establishing a highly polished and consistent corporate brand presence.
        </p>

        <div className="project-tags">
          <span className="info-tag">Visiting Card Design</span>
          <span className="info-tag">Brochure Design</span>
          <span className="info-tag">Letterhead Design</span>
          <span className="info-tag">Table Calendar Design</span>
          <span className="info-tag">Certificate Design</span>
          <span className="info-tag">Corporate Diary Design</span>
          <span className="info-tag">Flyer Design</span>
        </div>
      </section>

      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/Aulpha/Full1.webp" 
          alt="Aulpha Editorial Mockup" 
        />
      </div>
      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/Aulpha/Full2.webp" 
          alt="Aulpha Editorial Mockup" 
        />
      </div>
    
      <section className="project-split-images-section">
        <img src="https://ascentbw.com/Images/Aulpha/Half1.webp" alt="Aulpha Design" />
        <img src="https://ascentbw.com/Images/Aulpha/Half2.webp" alt="Aulpha Materials" />
      </section>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We crafted a complete corporate print kit for Aulpha Technologies, focusing on elegant typography, high-grade paper choices, and consistent branding across visiting cards, letterheads, and corporate diaries. Every touchpoint is aligned to project professionalism and build trust with clients."
        </div>
      </section>

      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/Aulpha/Full3.webp" 
          alt="Aulpha Page Details" 
        />
      </div>
    
      <section className="project-split-images-section">
        <img src="https://ascentbw.com/Images/Aulpha/Half3.webp" alt="Aulpha Brochure" />
        <img src="https://ascentbw.com/Images/Aulpha/Half4.webp" alt="Aulpha Diary" />
      </section>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "From the structured layout of the product brochures and marketing flyers to custom-designed table calendars and corporate achievement certificates, we ensured that Aulpha Technologies maintains a cohesive visual communication system across all offline and corporate materials."
        </div>
      </section>

      <RelatedWorks excludePath="/works/aulpha" />
      <Footer />
    </div>
  );
}
